module.exports = __webpack_public_path__ + "static/img/refrigerator.c43c6696.png";